<template>
  <el-dialog :title="$t('1760')" :close-on-click-modal="false" :visible.sync="visible" append-to-body>
    <el-row v-loading="isLoading">
      <el-row class="invite-tip">
        <p v-if="selectLength">{{ $t('invite_3', { x: selectLength }) }}</p>
        <p v-else>{{ $t('invite_4', { x: register_staff_count + no_register_staff_count }) }}</p>
        <p>{{ $t('1761', { x: register_staff_count }) }}</p>
        <p>{{ $t('1762', { x: no_register_staff_count }) }}</p>
        <span
          ><i class="el-icon-warning-outline"></i>{{ $t('1763') }}
          {{ $t('dc268f1d') }}
        </span>
      </el-row>
    </el-row>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">
        {{ $t('1764') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getInviteStaffData, inviteStaffRegisterFn } from 'api/org/staff'
import store from 'storejs'

export default {
  props: {
    tableSelectArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      disabled: false,
      register_staff_count: '', // 已激活员工数量
      no_register_staff_count: '', // 未激活员工数量
      isLoading: true,
      staff_ids: []
    }
  },
  computed: {
    selectLength() {
      return this.tableSelectArr && this.tableSelectArr.length
    }
  },
  methods: {
    init() {
      this.visible = true
      if (!this.tableSelectArr.length) this.getInviteStaffData()
      else {
        this.register_staff_count = 0
        this.no_register_staff_count = 0
        this.tableSelectArr.forEach(item => {
          this.staff_ids.push(item.staff_id)
          if (item.is_register_user === '1') this.register_staff_count += 1
          if (item.is_register_user === '0') this.no_register_staff_count += 1
        })
        this.isLoading = false
      }
    },
    async getInviteStaffData() {
      // const query = { staff_ids: this.staff_ids }
      this.isLoading = true
      const res = await getInviteStaffData()
      this.isLoading = false
      this.register_staff_count = res.data.register_staff_count
      this.no_register_staff_count = res.data.no_register_staff_count
    },
    async dataFormSubmit() {
      const query = { staff_ids: this.staff_ids }
      const res = await inviteStaffRegisterFn(query)
      if (res && res.code === 1) {
        this.$emit('refreshDataList')
        this.$message.success(res.message)
        store.set('invalid-time', Date.now())
        this.visible = false
        this.$emit('refreshTime')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-tip {
  padding: 0 40px;
  box-sizing: border-box;
  font-size: 14px;
  p {
    margin-bottom: 20px;
    color: rgba(0, 0, 0, 0.85);
  }
  span {
    color: rgba(0, 0, 0, 0.25);
  }
}
</style>
